import React from 'react';

import { CustomField } from '../../../../../../types/custom_field/customField';

import InnerFilterContent, { FilterInnerContentProps } from '../../../common/DropdownContent/DynamicFilterInnerContent';

export function CustomFieldFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<CustomField>) {
  return (
    <InnerFilterContent
      filterProps={{ filterProps, setFilterProps }}
      filter={filter}
      items={[...(filterProps.customField || [])]}
      text={item => (item as unknown as CustomField).name}
      onRemove={i => {
        filterProps.customField?.delete(i);
        if (!filterProps.customField?.size) filterProps.customField = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
